import { ITeamPlayersTable } from '@sky-it-livedata/livedata-sports-design-system';

import { ErrorName, WidgetError } from '../../../utils/errors';
import { isValidTeamPlayers } from './typeguards';
import { CreateTeamPlayersInputSchema, TeamPlayersPlayer } from 'appsync';
import { TeamPlayersQuery } from "../types";

const transformer = (obj: TeamPlayersQuery): ITeamPlayersTable => {
    if (isValidTeamPlayers(obj)) {
        CreateTeamPlayersInputSchema().parse(obj?.data?.getTeamPlayers);

        const players: TeamPlayersPlayer[] = (obj?.data?.getTeamPlayers?.players ?? [])
            .filter((player): player is TeamPlayersPlayer => player !== null);

        const playerList = players.map((player: TeamPlayersPlayer) => ({
            id: player.id ?? 'unknown',
            flag: player.flag ?? 'unknown',
            jerseyNum: player.jerseyNum ?? 0,
            height: player.height ?? 0,
            weight: player.weight ?? 0,
            name: player.name ?? 'unknown',
            surname: player.surname ?? 'unknown',
            fullName: player.fullname ?? 'unknown',
            birthdate: player.birthdate ?? null,
            playerPageLink: player.playerPageLink ?? undefined,
            role: (player.role ?? 'unknown') as ITeamPlayersTable['playerList'][number]['role'],
        }));

      return { playerList };

    } else {
        throw new WidgetError<ErrorName>({
            name: 'NO_VALID_DATA',
            message: 'Invalid transformer input, Error in TeamPlayersQuery object',
            data: obj
        });
    }
};

export default transformer;